import { Box, Link, Typography } from "@mui/material"
import { SmallLabelledText } from "../../styled/SmallLabelledText"
import { styled } from "@mui/styles"

const env = process.env.REACT_APP_ENV
const envConfig = require(`../../../config/config.${env}.json`)

const StyledLink = styled(Link)(({theme}) => {
    return ({
        color: theme.palette.secondary.main
    })
})

export function DlspLinks({taskDetails}) {

    if (!taskDetails) {
        return null
    }

    const gisMapLink = (
        <StyledLink target="_blank" rel="noreferrer" href="https://gis.northpower.com">GIS Map</StyledLink>
    )
    const lat = taskDetails?.gisICP?.body?.relatedData?.coordinatesWGS84?.yOrdinate
    const lng = taskDetails?.gisICP?.body?.relatedData?.coordinatesWGS84?.xOrdinate
    const googleLinkUrl = `https://maps.google.com/maps?q=${lat},${lng}`
    const googleMapLink = (
        <StyledLink target="_blank" rel="noreferrer" href={googleLinkUrl}>Google Map</StyledLink>
    )

    const assetsLinkUrl = `${envConfig.hikoRootUrl}/ni/asset_docs`
    const assetDocsLink = (
        <StyledLink target="_blank" rel="noreferrer" href={assetsLinkUrl}>Asset Docs</StyledLink>
    )
    const hikoLinkUrl = `${envConfig.hikoRootUrl}/ni/icp_scanning/documents?icp=${taskDetails?.decomICP.icp}`
    const hikoScannedDocsLink = (
        <StyledLink target="_blank" rel="noreferrer" href={hikoLinkUrl}>Decommissioning Records</StyledLink>
    )

    return (
        <Box>
            <Typography sx={{pb: 1}} variant="body2">Links</Typography>

            <SmallLabelledText label="GIS Local Maps" text={gisMapLink} />
            <SmallLabelledText label="Google Map" text={googleMapLink} />
            <SmallLabelledText label="Hiko Scanned ICP Documents" text={hikoScannedDocsLink} />
            <SmallLabelledText label="Asset Documents (requires asset number)" text={assetDocsLink} />
        </Box>
    )
}